import { useSetAtom } from "jotai";
import { MutationParameters } from "relay-runtime";

import { WhooshMutationError } from "../../../../../../../utils/hooks/useMutationWithError";
import { isCreatingBookingAtom } from "../../../../../atoms/stores";

/**
 * Creates error handlers that manage the isCreatingBookingAtom state.
 * All error paths set the atom to false to ensure the loading state is cleared.
 */
export const useCreateBookingErrorHandlers = () => {
  const setIsCreatingBooking = useSetAtom(isCreatingBookingAtom);

  return {
    onErrorCustom: () => {
      setIsCreatingBooking(false);
    },
    onPayloadError: () => {
      setIsCreatingBooking(false);
    },
    onCompletedErrorCustom: (errors: WhooshMutationError[]) => {
      setIsCreatingBooking(false);
      return errors;
    },
  };
};

/**
 * Extracts the booking ID from a mutation response.
 * Since useMutationWithError only calls onCompleted when success is true,
 * we don't need to check success again here.
 */
export const extractBookingId = <T extends MutationParameters>(
  response: T["response"]
): string | undefined => {
  return (response as any)?.responsePayload?.booking?.id;
};
